import { render, staticRenderFns } from "./PotreeSidebar.vue?vue&type=template&id=62e2ff67&scoped=true"
import script from "./PotreeSidebar.vue?vue&type=script&lang=js"
export * from "./PotreeSidebar.vue?vue&type=script&lang=js"
import style0 from "./PotreeSidebar.vue?vue&type=style&index=0&id=62e2ff67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e2ff67",
  null
  
)

export default component.exports